export const generateLinearPath = (startPos, endPos, link, fromNode, toNode) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const topToBottom = startPos.y < endPos.y;
    const start = topToBottom ? startPos : endPos;
    const end = topToBottom ? endPos : startPos;
    const startXOffset = (_b = (_a = fromNode.ports[link.from.portId].properties) === null || _a === void 0 ? void 0 : _a.xOffset, (_b !== null && _b !== void 0 ? _b : 0));
    const startX = start.x + startXOffset;
    const endXOffset = !link.to ? 0 : (_e = (_d = (_c = toNode) === null || _c === void 0 ? void 0 : _c.ports[link.to.portId].properties) === null || _d === void 0 ? void 0 : _d.xOffset, (_e !== null && _e !== void 0 ? _e : 0));
    const endX = end.x + endXOffset;
    const pStart = `${startX},${start.y}`;
    const pEnd = `${endX},${end.y}`;
    let pMid = (startX === endX || start.y === end.y) ? '' : `${endX},${start.y}`;
    const startYOffset = (_g = (_f = fromNode.ports[link.from.portId].properties) === null || _f === void 0 ? void 0 : _f.yOffset, (_g !== null && _g !== void 0 ? _g : 0));
    if (pMid !== '' && startYOffset) {
        pMid = `${startX},${start.y + startYOffset} ${endX},${start.y + startYOffset}`;
    }
    return `M${pStart} ${pMid} ${pEnd}`;
};
